module.exports = __webpack_public_path__ + "img/pgsoft.02707228.png";